// extracted by mini-css-extract-plugin
export default {"container":"ConfirmCancel_container__f4o3L","containerMobile":"ConfirmCancel_containerMobile__egVOP"};